import { render, staticRenderFns } from "./IcKebabMenu.vue?vue&type=template&id=36412c6d&scoped=true"
import script from "./IcKebabMenu.vue?vue&type=script&lang=js"
export * from "./IcKebabMenu.vue?vue&type=script&lang=js"
import style0 from "./IcKebabMenu.vue?vue&type=style&index=0&id=36412c6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36412c6d",
  null
  
)

export default component.exports